import { getComponentClasses } from '@99designs/frontend-components/utils/app';
import * as React from 'react';

interface Props {
    color?: string;
    percentageComplete: number;
    variations?: string[];
}

interface State {
    percentageComplete: number;
}

class ProgressBar extends React.Component<Props, State> {
    static defaultProps: Partial<Props> = {
        variations: [],
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            percentageComplete: 0,
        };
    }

    componentDidMount() {
        this.setState(() => ({
            percentageComplete: this.props.percentageComplete,
        }));
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        this.setState(() => ({
            percentageComplete: nextProps.percentageComplete,
        }));
    }

    render() {
        const style = {
            width: this.state.percentageComplete + '%',
        };

        const classes = getComponentClasses('create-progress-bar', this.props.variations);

        return (
            <div className={classes} style={{ color: this.props.color }} role="progressbar">
                <div className="create-progress-bar__progress" style={style} />
            </div>
        );
    }
}

export default ProgressBar;
